import React, { useId } from 'react';

/** トピックの見出し (SCR-D-001 DP-D-003。1.6 で DP-D-002 と揃えて定まった) */
export const TOPICS_HEADING = 'トピック';

/** トピックが 0 個のときの文言 (SCR-D-001 DP-D-003。1.6) */
export const NO_TOPICS_MESSAGE = '抽出されたトピックはありません。';

/**
 * トピックタグ (SCR-D-001 DP-D-003。chip 形式、0〜10 個)。
 *
 * 最大 10 個は抽出側 (BE) の上限であり、画面では切り詰めない (受け取った分を出す)。
 * **0 個のときも見出しを残し、文言を出す** (1.6)——欄ごと出さないと、抽出が行われなかったのか、
 * 行われて 0 個だったのかが利用者に分からない。
 *
 * @param {{topics: string[]}} props
 */
function TopicTags({ topics }) {
    const headingId = useId();
    const list = topics || [];
    return (
        <section className="diar-topics" aria-labelledby={headingId}>
            <h4 id={headingId} className="diar-section-heading">{TOPICS_HEADING}</h4>
            {list.length === 0 ? (
                <p className="diar-topics-empty">{NO_TOPICS_MESSAGE}</p>
            ) : (
                <ul className="diar-topic-list">
                    {list.map((topic, index) => (
                        // トピックは同じ文字列が 2 回返りうるため、位置も key に含める
                        <li key={`${index}-${topic}`} className="diar-topic-chip">{topic}</li>
                    ))}
                </ul>
            )}
        </section>
    );
}

export default TopicTags;
